import { render, staticRenderFns } from "./Initialize.vue?vue&type=template&id=520ce53e&"
import script from "./Initialize.vue?vue&type=script&lang=js&"
export * from "./Initialize.vue?vue&type=script&lang=js&"
import style0 from "./Initialize.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports